import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { AuthStore } from '@yoshu-lib/core/auth/auth.store'

/**
 * A route guard function that determines whether a user is allowed to activate a route.
 *
 * This guard checks if there is a currently authenticated user in the `AuthStore`.
 * Token validation is handled by the backend via HttpOnly cookies - if a token is
 * expired, the interceptor will handle refresh or redirect to login.
 *
 * @returns `true` if the user is authenticated, otherwise redirects to login.
 */
export const authGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore)
  const router = inject(Router)

  if (!authStore.isLoggedIn()) {
    router.navigate(['/login'])
    return false
  }

  return true
}
